/**
 * Formats the date to be `DD Mon` (e.g. `01 Jan`)
 * @param {*} dateString The ISO formatted date string
 * @returns A new date string that is formatted as per the above description.
 */
export function toDDMonFormatAEST(dateString) {
    const inputDate = new Date(dateString);
    const options = {
        day: "2-digit",
        month: "short",
        timeZone: "Australia/Sydney"
    };
    const formattedDate = inputDate.toLocaleString("en-AU", options);
    return formattedDate;
}

/**
 * Formats the date to be DD Mon Year
 * @param {*} dateString 
 * @returns 
 */
export function toDDMonYearFormatAEST(dateString) {
    const inputDate = new Date(dateString);
    const options = {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
        timeZone: "Australia/Sydney",
    };
    const formattedDate = inputDate.toLocaleDateString("en-AU", options);
    const datePart = formattedDate.split(',')[0]; // Extract time portion
    const timePart = formattedDate.split(',')[1].trim(); // Extract date portion
    return timePart + " " + datePart;
}